"use client";

import FinancialCalendar from "@/components/infront/financial-calendar";
import PageHeading from "@/components/page-heading";
import { TabBar } from "@/components/tab-bar";
import { useState } from "react";

const TABS = [
  { label: "Sverige", countryCode: "SE" },
  { label: "USA", countryCode: "US" },
];

export default function Page() {
  const [activeTab, setActiveTab] = useState("SE");

  return (
    <>
      <PageHeading text="Företagskalender" />
      <TabBar
        tabs={TABS.map((t) => ({ label: t.label, value: t.countryCode }))}
        active={activeTab}
        onChange={setActiveTab}
      />
      {activeTab === "SE" && (
        <FinancialCalendar countryCode="SE" showTicker />
      )}
      {activeTab === "US" && (
        <FinancialCalendar countryCode="US" showTicker />
      )}
    </>
  );
}
